import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import type { SWRConfiguration } from 'swr'

export const useFacilitiesMeta = (options?: SWRConfiguration) => {
  const client = useGyymClient()
  return useGyymSWR(client.user.facilities.searchMetadata, options)
}
